import { render, staticRenderFns } from "./AuthorizedStaffHeader.vue?vue&type=template&id=4f71f9ec"
import script from "./AuthorizedStaffHeader.vue?vue&type=script&lang=js"
export * from "./AuthorizedStaffHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports